import { MixAndMatchGridHandler } from "./MixAndMatchGrid";

let elements = document.querySelectorAll<HTMLElement>('.scope-mnm');

if (elements.length > 0) {
    for (let i = 0; i < elements.length; i++) {
        new MixAndMatchGridHandler(elements[i]);
    }
}